import { useQuery } from '@tanstack/react-query'
import { useCabanaApi } from '../hooks/useCabanaApi'

export const useRandomQuote = () => {
  const { getRandomQuotes } = useCabanaApi()

  const { data, isLoading } = useQuery({
    queryKey: ['Quotes'],
    queryFn: () => getRandomQuotes(),
    cacheTime: 0,
    refetchOnMount: true,
  })
  return { data, isLoading }
}
